import React from 'react';
import { Box, Dialog, IconButton } from '@mui/material';

import closeIcon from '../../../Assets/Images/v3/icon-close.svg';

export interface ModalShellProps {
	open: boolean;
	onClose: () => void;
	children: React.ReactNode;
}

const ModalShell = ({ open, onClose, children }: ModalShellProps) => {
	return (
		<Dialog
			open={open}
			onClose={onClose}
			PaperProps={{
				sx: {
					position: 'relative',
					width: '590px',
					maxWidth: 'calc(100% - 32px)',
					borderRadius: '12px',
					boxSizing: 'border-box',
					padding: { xs: '24px 20px', sm: '32px 27px' },
					display: 'flex',
					flexDirection: 'column',
					gap: '26px'
				}
			}}
			BackdropProps={{
				sx: { backgroundColor: 'rgba(41, 41, 41, 0.1)', backdropFilter: 'blur(27.45px)' }
			}}
		>
			<IconButton
				aria-label="Close"
				onClick={onClose}
				sx={{
					position: 'absolute',
					top: { xs: '20px', sm: '32px' },
					right: { xs: '20px', sm: '27px' },
					padding: 0,
					width: '24px',
					height: '24px',
					zIndex: 1
				}}
			>
				<Box component="img" src={closeIcon} alt="" sx={{ width: '24px', height: '24px' }} />
			</IconButton>

			{children}
		</Dialog>
	);
};

export default ModalShell;
